module.exports = __webpack_public_path__ + "images/dashboard_e9d9a57.png";